import {
	AppBar,
	createStyles,
	Dialog,
	IconButton,
	Theme,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CreateIcon from '@material-ui/icons/Create';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/styles';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CareerDetail from 'src/containers/CareerDetail';
import CurriculumDetail from 'src/containers/CurriculumDetail';
import {
	ISearchCategoryItem,
	ISelectedCareer,
	setCategorySelectedCareers,
} from '../actions/search';
import { IRootState } from '../reducers';
import { isMobile } from '../utils/MobileCheck';

import CloseIcon from '@material-ui/icons/Close';
import { UpwardTransition } from 'src/utils';

import SkillDetail from 'src/containers/SkillDetail';
import i18next from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		careerDialog: {
			width: '80%',
		},
		listItem: {
			borderRadius: '12px',
			height: '50px',
			paddingLeft: '5px',
		},
	});

interface ITreeState {
	open: boolean;
	openCareerDetailDialog: boolean;
	openCurriculumDetailDialog: boolean;
	openSkillDetailDialog: boolean;
	careerID: string;
}

/**
 * カテゴリツリー
 */
class CategoryTree extends React.Component<IProps, ITreeState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			open: false,
			openCareerDetailDialog: false,
			openCurriculumDetailDialog: false,
			openSkillDetailDialog: false,
		};

		this.toggleTree = this.toggleTree.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onClickCheckbox = this.onClickCheckbox.bind(this);
		this.showCareerDetail = this.showCareerDetail.bind(this);
		this.showCurriculumDetail = this.showCurriculumDetail.bind(this);
		this.handlecloseDetailDialog = this.handlecloseDetailDialog.bind(this);
	}

	public render() {
		const {
			type,
			level,
			text,
			treeChildren,
			checkBoxDisplayFlg,
			id,
			careerType,
			selectedCareers,
		} = this.props;
		const selectedCareerIds = selectedCareers.map(
			(selected: ISelectedCareer): string => {
				return selected.careerId;
			}
		);
		let itemName = '';
		if (isMobile() && text.length > 9) {
			itemName = text.substring(0, 9) + '....';
		} else {
			itemName = text;
		}
		if (type === 0) {
			// タイプが「種別」の場合はListを作って子は再帰で取得
			return (
				<List
					component="nav"
					style={{
						paddingBottom: 0,
						paddingLeft:
							level === 0 || (isMobile() && level > 3) ? 0 : 40,
					}}
				>
					<ListItem
						button={true}
						onClick={this.toggleTree}
						className={this.props.classes.listItem}
						style={{
							backgroundColor:
								level === 0 ? '#CDE3ED' : '#DCDCDC',
						}}
					>
						{treeChildren &&
						treeChildren.length !== 0 &&
						this.state.open ? (
							<ExpandMore />
						) : (
							<ChevronRight />
						)}
						{isMobile() && (
							<Tooltip
								title={i18next.t(text, {
									ns: 'force',
								})}
								placement="top-start"
							>
								<ListItemText
									inset={true}
									primary={i18next.t(itemName, {
										ns: 'force',
									})}
									style={{ paddingLeft: '10px' }}
								/>
							</Tooltip>
						)}
						{!isMobile() && (
							<ListItemText
								inset={true}
								primary={i18next.t(itemName, { ns: 'force' })}
								style={{ paddingLeft: '10px' }}
							/>
						)}
					</ListItem>
					{treeChildren &&
						treeChildren.map(
							(
								node: ISearchCategoryItem,
								i: number
							): JSX.Element => (
								<Collapse
									key={i}
									in={this.state.open}
									timeout="auto"
									unmountOnExit={true}
								>
									<CategoryTree
										{...node}
										classes={this.props.classes}
										pushHistory={this.props.pushHistory}
										selectedCareers={
											this.props.selectedCareers
										}
										setSelectedCareers={
											this.props.setSelectedCareers
										}
										token={this.props.token}
									/>
								</Collapse>
							),
							this
						)}
				</List>
			);
		}
		// タイプが「キャリア」の場合
		return (
			<>
				<List
					component="nav"
					style={{
						paddingBottom: 0,
						paddingLeft: 40,
					}}
				>
					<ListItem
						className={this.props.classes.listItem}
						style={{ backgroundColor: '#fff' }}
					>
						<CreateIcon style={{ marginLeft: 10 }} />
						<ListItemText
							style={{
								cursor: 'pointer',
								paddingLeft: '10px',
							}}
							inset={true}
							primary={
								<span
									style={{ color: 'blue' }}
									onClick={this.onClick}
									data-careertype={careerType}
									data-id={id}
								>
									{itemName}
								</span>
							}
						/>
						{checkBoxDisplayFlg && (
							<ListItemIcon>
								<Checkbox
									checked={
										selectedCareerIds.indexOf(id) !== -1
									}
									data-id={id}
									data-careertype={careerType}
									onClick={this.onClickCheckbox}
									color="primary"
								/>
							</ListItemIcon>
						)}
					</ListItem>
				</List>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('CategoryTree_0001')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCurriculumDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('CategoryTree_0002')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CurriculumDetail curriculumId={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openSkillDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('CategoryTree_0003')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillDetail skillId={this.state.careerID} />
				</Dialog>
			</>
		);
	}

	protected toggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ open: !this.state.open });
	}

	protected onClick(e: React.MouseEvent<HTMLElement>) {
		const id = e.currentTarget.getAttribute('data-id') || '';
		const careerType =
			e.currentTarget.getAttribute('data-careertype') || '';
		const { token } = this.props;
		if (id && id !== '') {
			if (careerType === '0') {
				// 研修
				this.showCareerDetail(id);
			} else if (careerType === '10') {
				// スキル
				this.showSkillDetail(id);
			} else if (careerType === '90') {
				// カリキュラム
				this.showCurriculumDetail(id, token);
			}
		}
	}

	/**
	 * チェックボックス変更時処理
	 * @param e イベント
	 */
	protected onClickCheckbox(e: React.MouseEvent<HTMLElement>) {
		const careerId = e.currentTarget.getAttribute('data-id');
		const careerType = e.currentTarget.getAttribute('data-careertype');
		if (careerId && careerId !== '' && careerType && careerType !== '') {
			// 同じcareerIdがあれば除外
			const newSelectedCareers: ISelectedCareer[] = this.props.selectedCareers.filter(
				(selected: ISelectedCareer): boolean => {
					return careerId !== selected.careerId;
				}
			);
			// 除外したものが無ければ追加
			if (
				newSelectedCareers.length === this.props.selectedCareers.length
			) {
				newSelectedCareers.push({
					careerId,
					careerType,
					classId: '',
				});
			}
			this.props.setSelectedCareers(newSelectedCareers);
		}
	}

	protected showCareerDetail(careerId: string) {
		this.setState({
			careerID: careerId,
			openCareerDetailDialog: true,
		});
	}

	protected showCurriculumDetail(curriculumId: string, token: string) {
		this.setState({
			careerID: curriculumId,
			openCurriculumDetailDialog: true,
		});
	}

	protected showSkillDetail(careerId: string) {
		this.setState({
			careerID: careerId,
			openSkillDetailDialog: true,
		});
	}

	protected handlecloseDetailDialog() {
		this.setState({
			careerID: '',
			openCareerDetailDialog: false,
			openCurriculumDetailDialog: false,
			openSkillDetailDialog: false,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	setSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setCategorySelectedCareers({ selectedCareers })),
});

export interface ICategoryTreeProps extends ISearchCategoryItem {
	selectedCareers: ISelectedCareer[];
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICategoryTreeProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CategoryTree);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/CategoryTree.tsx